import React, { memo, useMemo } from 'react';
import ReactJson from 'react-json-view';
import { useRecordContext } from 'react-admin';

import { useSignedUrl } from './s3.js';

export const S3ImageField = ({ source }) => {
  const record = useRecordContext();
  let url = record[source];
  let signedUrl = useSignedUrl(url);
  const style = {
    maxHeight: 300,
    maxWidth: 300
  };
  return signedUrl && <img src={signedUrl} style={style} alt="" />;
};

S3ImageField.defaultProps = {
  addLabel: true
};

export const S3FileField = ({ source }) => {
  const record = useRecordContext();
  let url = record[source];
  let signedUrl = useSignedUrl(url);
  return (
    signedUrl && (
      <a href={signedUrl} target="_blank" download rel="noopener noreferrer">
        {url.original_filename || 'Download'}
      </a>
    )
  );
};

S3FileField.defaultProps = {
  addLabel: true
};

const MemoizedReactJson = memo(({ data }) => (
  <ReactJson
    src={data || {}}
    theme="monokai"
    collapsed={1}
    displayDataTypes={false}
    displayObjectSize={true}
    enableClipboard={true}
    collapseStringsAfterLength={80}
    style={{ padding: 16, borderRadius: 4, fontSize: 13, lineHeight: 1.5 }}
  />
));

export const JSONField = ({ source, ...props }) => {
  const record = useRecordContext();
  const json = record[source];
  const stableData = useMemo(() => json, [JSON.stringify(json)]);
  return <MemoizedReactJson data={stableData} />;
};

JSONField.defaultProps = {
  addLabel: true
};
